import React from 'react';
import PropTypes from 'prop-types';

import './stripeForm.scss';

const cardStyles = {
  base: {
    color: '#32325d',
    lineHeight: '18px',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4',
    },
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a',
  },
};

class StripeForm extends React.Component {
  state = {
    errorText: null,
  };

  componentDidMount() {
    const elements = this.props.stripe.obj.elements();
    const card = elements.create('card', {
      style: cardStyles,
      hidePostalCode: true,
    });

    card.mount('#card-element');
    card.on('ready', () => card.focus());
    card.on('change', e => {
      this.setState({errorText: (e.error && e.error.message) || ''});
      this.props.updateSubmitButtonEnabled(!e.error && e.complete);
    });

    this.props.setProcessor({...this.props.stripe, card});
  }

  render() {
    return (
      <div>
        <div id="card-element" />

        {this.state.errorText && (
          <div id="card-errors">{this.state.errorText}</div>
        )}
      </div>
    );
  }
}

StripeForm.propTypes = {
  stripe: PropTypes.shape({
    obj: PropTypes.object.isRequired,
    card: PropTypes.object,
  }).isRequired,

  // functions
  setProcessor: PropTypes.func.isRequired,
  updateSubmitButtonEnabled: PropTypes.func.isRequired,
};

export default StripeForm;



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/StripeForm/index.js